import { useState } from 'react'
import { IFilteredParkAreaList } from 'types/ParkAreaType'

export default function useParkAreaResModal() {
  const [selectedPark, setSelectedPark] = useState<IFilteredParkAreaList>()
  const [modal, setModal] = useState(false)
  const [notification, setNotification] = useState(false)

  const closeModal = () => setModal(false)
  const openModal = (area?: IFilteredParkAreaList) => {
    setModal(true)
    if (area) setSelectedPark(area)
  }

  return { selectedPark, setSelectedPark, modal, openModal, closeModal, notification, setNotification }
}
